import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const agingService = { getAging }

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const params = { page: filter?.pageNumber, size: filter?.pageSize }
  if (filter?.debtorCode) params.debtor_code = filter.debtorCode
  if (filter?.dateFrom) params.date_from = filter.dateFrom
  if (filter?.dateTo) params.date_to = filter.dateTo
  if (filter?.sortBy) params.sort_by = filter.sortBy
  if (filter?.orderBy) params.order_by = filter.orderBy
  return params
}

export function getAging(filter) {
  return apiHelper(API_URL).get('/aging', { params: buildParams(filter) })
}
